var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg13471LogoCompletaPreto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1325 426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M906.24,116.18c-41.94,0-60,19.77-69.89,25.36V57.25h-42.49v249.1h41.8v-23.64c2.28,2.29,25.22,29.81,74.24,29.81s95.71-34.54,95.71-99.37c0-53.19-35.57-96.97-99.38-96.97ZM899.05,276.2c-34.88,0-55.52-22.35-62.7-26.73v-71.61c6.61-5.02,25.8-25.36,61.33-25.36s64.76,24.19,64.76,62.02c0,42.23-32.26,61.68-63.39,61.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1026.46,
    y: 57.25,
    width: 42.49,
    height: 37.69
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1026.46,
    y: 122.35,
    width: 42.49,
    height: 184
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.1,276.03c-28.32,0-28.98-19.85-28.98-28.12v-88.63h64.07v-36.93h-64.07V57.25h-42.49v65.1h-32.89v36.93h32.89v99.79c0,37.11,18.05,53.45,62.7,53.45,23.66,0,40.66-3.43,45.92-4.11v-37.35c-10.37,2.61-25.02,4.97-37.15,4.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.23,127.32c-11.59,7.04-19.65,18.79-21.93,22.44h-1.03l-9.52-17.86c-3.13-5.88-9.25-9.55-15.92-9.55h-17.05c-.31,9.95-2.02,27.92-9.73,40.75-13.6,22.62-35.47,31.1-35.47,31.1,0,0,24.17-3.16,45.2-20.53v132.68h42.49v-97.65c0-9.27-.12-31.88,23.3-43.34,25.7-12.58,57.22-2.57,57.22-2.57v-45.91c-2.29-.45-33.21-4.33-57.56,10.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.37,113.83c-7.66-27.75-54.18-40.9-116.55-37.26-20.84-13.29-45.75-20.69-72.32-19.91-70.54,2.06-126.05,60.91-123.99,131.44,2.06,70.54,60.91,126.05,131.44,123.99,66.62-1.94,119.81-54.56,123.78-119.82,41.12-25.88,64.14-54.84,57.63-78.44ZM340.9,194.23c-3.74-53.36,38.06-99.64,93.37-103.36,42.66-2.87,80.87,20.42,97.84,55.7-26.38,14.78-62.49,29.31-103.38,40.59-31.16,8.6-60.89,14.14-86.66,16.67-.55-3.15-.95-6.35-1.17-9.6ZM447.2,284.41c-30,2.02-57.81-8.86-77.65-27.73,23.32-2.83,48.15-7.67,73.63-14.7,36.12-9.96,68.97-23,96.4-37.52-7.98,42.89-45.3,76.78-92.38,79.95ZM551.59,136.2c-8.31-20.4-21.73-38.11-38.62-51.62,34.81-1.16,58.65,4.7,62.21,17.6,2.64,9.59-6.31,21.58-23.59,34.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,57s-93.78-.39-122.73,96.11l-31.06,103.56-62.36-134.32h-46.6l73.67,151.79c29.45,60.72-37.3,57.56-41.02,57.56-10.07,0-24.08-4.11-24.08-4.11v36.32c3.88,1.37,16.78,5.48,37.01,5.48,28.73,0,69.56-9.41,91.44-70.78l50.9-152.36c22.66-64.52,74.84-89.26,74.84-89.26Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13471LogoCompletaPreto);
export default __webpack_public_path__ + "static/media/13471_Logo_Completa_preto.064125bc27fc62008b7ab76b37ebdf94.svg";
export { ForwardRef as ReactComponent };